// removed by extract-text-webpack-plugin
module.exports = {"modal":"modal--3FHgo","is-open":"is-open--2SpZ-","background":"background--3BOs2","content":"content--1Tcbu","button-group":"button-group--3R8K_"};


//////////////////
// WEBPACK FOOTER
// ./client/components/modal/modal.scss
// module id = 480
// module chunks = 0